/* tslint:disable:ban-types */
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoadingComponent } from '../../_components/shared/loading/loading.component';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime, filter, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private dialogRef: MatDialogRef<LoadingComponent>;
  constructor(private dialog: MatDialog) { }
  public spinnerMoadalClosed: Subject<boolean> = new Subject();

  public show() {

    // this.dialogRef = this.dialog.open(LoadingComponent, {
    //   panelClass: 'transparent',
    //   disableClose: true
    // });
  }

  public hide() {
    // if (this.dialogRef) {
    //   this.dialogRef.close();
    // }

  }

  public hideAll() {
    // In some cases it appears that hide() doesn't always hide the dialog.  There may be multiple references to 
    // dialogRef in memory and close does not close them correctly.  HideAll will use dialog.closeAll() to close
    // all open dialogs.  This is used from the map to ensure that the loading dialog is closed when the map is loaded.
    // if (this.dialog) {
    //   this.dialog.closeAll();
    // }
  }




  // interceptor, data-studio component
  toggle(toggle: boolean) {
    toggle ? this.show() : this.hide();
  }

  _loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
  public loadingMaxTimeout$ = this._loading.asObservable().pipe(
    filter((loading: boolean) => {
      if (loading) { return true }
      return false
    }),
    debounceTime(1000),
    tap(() => {
      this.loadingMap.clear()
      this.setLoading(false, "LoadingSpinnerMaxTimeout")
    })
  )
  loadingMap: Map<string, boolean> = new Map<string, boolean>()
  setLoading(loading: boolean, url: string) {
    if (!url) {
      throw new Error('The request URL must be provided to the LoadingService.setLoading function');
    }
    if (loading === true) {
      this.loadingMap.set(url, loading);
      this._loading.next(true);
    } else if (loading === false && this.loadingMap.has(url)) {
      this.loadingMap.delete(url);
    }
    if (this.loadingMap.size === 0) {
      this._loading.next(false);
    }
  }
  setSpinnerStatus(value: boolean) {
    this.spinnerMoadalClosed.next(value);
  }
  getSpinnerStatus() {
    return this.spinnerMoadalClosed.asObservable();
  }

}


// export enum ENamedEvent {
//   DATA_STUDIO_LOAD = "DATA_STUDIO_LOAD"
// }